export default __webpack_public_path__ + "static/media/export.f312987c.svg";